import React from 'react';
import MiniLogoImg from '../../assets/vendor/mini-logo.png';
const MiniLogo = () => {
  return (
    <img
      alt="SignageTec logo"
      width={32}
      height={32}
      src={MiniLogoImg}
      style={{ display: 'block' }}
    />
  );
};

export default MiniLogo;
